export default "__VITE_ASSET__DK73M13w__"